import { fork, take, call, put } from "redux-saga/effects";
import types from "./types";
import { apiDirect, postAPIWithoutModule } from "../../api/generic";
import {
  getDowngradeReqDetailsResp,
  getSubscriptionDetailsResp,
  getSubscriptionPaymentDetailsResp,
  getSubscriptionPlanResp,
  getTestimonalDataResp,
} from "./actions";

export function* doGetSubscription() {
  while (true) {
    const { payload } = yield take(types.GET_SUBSCRIPTION);
    const response = yield call(apiDirect, payload);
    yield put(getSubscriptionPlanResp(response));
  }
}

export function* doGetTestimonalData() {
  while (true) {
    const { payload } = yield take(types.GET_TESTIMONAL);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getTestimonalDataResp(response));
  }
}

export function* doGetSubscriptionDetails() {
  while (true) {
    const { payload } = yield take(types.GET_SUBSCRIPTION_DETAILS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getSubscriptionDetailsResp(response));
  }
}

export function* doGetSubscriptionPaymentDetails() {
  while (true) {
    const { payload } = yield take(types.GET_SUBSCRIPTION_PAYMENT_DETAILS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getSubscriptionPaymentDetailsResp(response));
  }
}

export function* doGetDowngradeReqDetails() {
  while (true) {
    const { payload } = yield take(types.GET_DROWNGRADE_REQUEST);
    const response = yield call(postAPIWithoutModule, payload);
    console.log("Downgrade Request Response", response);
    yield put(getDowngradeReqDetailsResp(response));
  }
}

function* getRes() {
  yield fork(doGetSubscription);
  yield fork(doGetTestimonalData);
  yield fork(doGetSubscriptionDetails);
  yield fork(doGetSubscriptionPaymentDetails);
  yield fork(doGetDowngradeReqDetails);
}

export default getRes;
